/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';
import type { RecoverableFactor } from './RecoverableFactor';
import {
    RecoverableFactorFromJSON,
    RecoverableFactorFromJSONTyped,
    RecoverableFactorToJSON,
} from './RecoverableFactor';

/**
 * 
 * @export
 * @interface RecoverRequest
 */
export interface RecoverRequest {
    /**
     * 
     * @type {PersonHandle}
     * @memberof RecoverRequest
     */
    handle: PersonHandle;
    /**
     * 
     * @type {RecoverableFactor}
     * @memberof RecoverRequest
     */
    factor: RecoverableFactor;
}

/**
 * Check if a given object implements the RecoverRequest interface.
 */
export function instanceOfRecoverRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "handle" in value;
    isInstance = isInstance && "factor" in value;

    return isInstance;
}

export function RecoverRequestFromJSON(json: any): RecoverRequest {
    return RecoverRequestFromJSONTyped(json, false);
}

export function RecoverRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecoverRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'handle': PersonHandleFromJSON(json['handle']),
        'factor': RecoverableFactorFromJSON(json['factor']),
    };
}

export function RecoverRequestToJSON(value?: RecoverRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'handle': PersonHandleToJSON(value.handle),
        'factor': RecoverableFactorToJSON(value.factor),
    };
}

